import { styled } from '@components-shared/src/stitches';

export const ClearSearchButton = styled('button', {
  color: '#171717',

  marginRight: '8px',

  '@tablet': {
    color: '#A3A3A3',

    marginRight: 'unset',
  },

  path: {
    transition: 'stroke 0.3s',
  },
  '&:hover': {
    color: '$neutral900',
  },
});

export const SearchBarContainer = styled('div', {
  display: 'flex',
  width: '100%',
  '@tablet': {
    marginLeft: 0,
  },
});

export const SearchInputContainer = styled('div', {
  background: 'white',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 6,
  width: '99%',
  height: 40,
  border: '1px solid $neutral300',

  '@tablet': {
    border: 'none',
    borderRadius: '$sm',
    minWidth: 277,
    height: 40,
    padding: '11px 12px',
    background: '$neutral50',
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(24px)',
    transition: 'background-color 0.3s ease-in-out',
    '.search-icon': {
      color: '$white',
    },
    '&:hover, &:focus': {
      backgroundColor: '$white',
      '.search-icon': {
        color: '$black',
      },
    },
  },

  '@desktop': {
    paddingLeft: 16,
  },

  '&:focus-within': {
    background: '$white',
  },

  variants: {
    main: {
      true: {
        zIndex: '$search',
      },
    },
    isBlurBackground: {
      true: {
        '.search-icon': {
          color: '$white',
        },
        '&:hover, &:focus': {
          backgroundColor: '$white',
          '.search-icon': {
            color: '$black',
          },
        },
      },
      false: {
        border: '1px solid $neutral300',
        '.search-icon': {
          color: '$black',
        },
      },
    },
    isActive: {
      true: {
        '@tablet': {
          backgroundColor: '$white',
          '.search-icon': {
            color: '$black',
          },
        },
      },
    },
    isGreyBackground: {
      true: {
        backgroundColor: '$base100',
      },
    },
  },
  compoundVariants: [
    {
      isActive: true,
      isGreyBackground: true,
      css: {
        backgroundColor: '$base100',
      },
    },
  ],
});

export const SearchInput = styled('input', {
  background: 'transparent',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '17px',
  color: '$neutral900',
  paddingLeft: '2px',
  height: 41,
  margin: '0.1rem 0.5rem 0.1rem 0.5rem',
  width: '100%',
  border: 'none',
  outline: '$blue400',
  justifyContent: 'center',

  '@tablet': {
    height: 35,
    margin: '0.1rem 0.5rem 0 0.5rem',
  },

  '&::placeholder': {
    color: '$neutral400',
  },
  '&:focus': {
    '&::placeholder': {
      color: '$neutral600',
    },
  },
  variants: {
    isBlurBackground: {
      true: {
        '@tablet': {
          transition: 'color 0.3s ease-in-out',
          '&::placeholder': {
            color: '$white',
            opacity: 0.8,
          },
          '&:focus, &:hover': {
            '&::placeholder': {
              color: '$black',
              opacity: 0.5,
            },
          },
        },
      },
      false: {
        '&::placeholder': {
          color: '$neutral400',
        },
        '&:focus': {
          '&::placeholder': {
            color: '$neutral600',
          },
        },
      },
    },
  },
});

export const Overlay = styled('div', {
  display: 'none',
  '@tablet': {
    display: 'block',
    zIndex: '$overlay',
    height: '100%',
    width: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    overflowX: 'hidden',
    transition: '0.5s',
  },
});

export const MobileSearch = styled('div', {
  width: '100%',
  height: '100%',
  marginTop: 6,
});
